var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.125 12C2.125 6.47715 6.60215 2 12.125 2C17.6478 2 22.125 6.47715 22.125 12C22.125 14.8358 20.9437 17.3968 19.0483 19.2159C17.2521 20.9396 14.8117 22 12.125 22C9.43832 22 6.99786 20.9396 5.20175 19.2159C3.30629 17.3968 2.125 14.8358 2.125 12ZM17.7837 18.4824C17.3828 17.283 16.2495 16.4186 14.9157 16.4186H9.3343C8.00047 16.4186 6.86724 17.283 6.46627 18.4824C7.97944 19.8045 9.95814 20.6047 12.125 20.6047C14.2919 20.6047 16.2706 19.8045 17.7837 18.4824ZM12.125 4.7907C9.68467 4.7907 7.7064 6.76897 7.7064 9.2093C7.7064 11.6496 9.68467 13.6279 12.125 13.6279C14.5653 13.6279 16.5436 11.6496 16.5436 9.2093C16.5436 6.76897 14.5653 4.7907 12.125 4.7907Z",
    fill: "url(#paint0_linear_35428_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35428_10",
    x1: -4.4968,
    y1: 52.3125,
    x2: 23.3226,
    y2: 52.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/user-active.e6af539abadfe511739876df22d03f28.svg";
export { ForwardRef as ReactComponent };